<template>
    <!-- 医美11-12新激励排行榜 -->
    <div class="ranking">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :error.sync="error" error-text="请求失败，点击重新加载" :immediate-check="false">
            <div v-for="(v, k) in jobTabs" :key="k">
                <div v-if="currentJobTab == k + 1">
                    <!-- banner -->
                    <img class="banner" :src="`${v.url}20251106/${v.bannerImg}.png`" alt="banner">
                    <!-- 奖品 -->
                    <div class="reward-box">
                        <div v-if="currentJobTab === '1'">
                            <div class="bear-palm">
                                <p>获奖奖品</p>
                                <div class="reward-bot">
                                    <span>激励对象：</span>
                                    <p>全体美学顾问（含院长、专家、顾问）</p>
                                </div>
                                <div class="reward-bot">
                                    <span>激励机制：</span>
                                    <p>个人9800爆品销售人数目标105%达成后，取销售金额前三名瓜分奖，多干多拿</p>
                                </div>
                                <div :class="['prizeWrapper', { 'flex-between': currentJobTab == 1, 'flex-around': currentJobTab == 2 }]">
                                    <div class="prizeRank">
                                        <div class="prizeTitle">小组PK前3名瓜分奖金池</div>
                                        <div v-for="(rewardItem, rewardIndex) in groupNoRewardAmtList(currentGroupTab)" :key="rewardIndex">
                                            <span v-for="(value, key) in rewardItem" :key="key">{{ value }}元奖金</span>
                                        </div>
                                    </div>
                                    <div>
                                        <img src="https://staticwecom.beautyfarm.com.cn/20251106/cash.png" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="currentJobTab === '2'">
                            <div class="bear-palm">
                                <p>获奖奖品</p>
                                <div class="reward-bot">
                                    <span>激励对象：</span>
                                    <p>全体美学顾问（含院长、专家、顾问）</p>
                                </div>
                                <div class="reward-bot">
                                    <span>激励机制：</span>
                                    <p>个人11+12消费目标达标，根据无创消费额(单个客户无创消费不低于2980元)联合其他品项消费累计累计计算积分进行激励;每组取TOP3，获得定额奖金</p>
                                </div>
                                <div class="reward-bot">
                                    <span>积分规则：</span>
                                    <p>单个客户无创连带消费满1W，获1分;满2W，获3分;满3W，获5分;满5W，获10分</p>
                                </div>
                                <div :class="['prizeWrapper', { 'flex-between': currentJobTab == 1, 'flex-around': currentJobTab == 2 }]">
                                    <div class="prizeRank">
                                        <div class="prizeTitle">小组积分前3名</div>
                                        <div v-for="(rewardItem, rewardIndex) in groupNoRewardAmtList(currentGroupTab)" :key="rewardIndex">
                                            <span v-for="(value, key) in rewardItem" :key="key">{{ key }}：{{ value }}元</span>
                                        </div>
                                    </div>
                                    <div>
                                        <img src="https://staticwecom.beautyfarm.com.cn/20251106/cash.png" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="arrivedWrapper" v-if="myData">
                            <div class="countWraper">
                                <div class="title">{{ currentJobTab == 1 ? '目标达成率' : '消费额达成率' }}</div>
                                <div :class="['content', { 'isReach': dataInfo.isReach == 1 }]">{{ myData.achievementRate }}%<span>{{ dataInfo.isReach == 1 ? '（已达标）' : '（未达标）' }}</span> </div>
                            </div>
                            <div class="saleWrapper">
                                <div class="title">{{ currentJobTab == 1 ? '销售人数' : '我的积分' }}</div>
                                <div class="content">{{ currentJobTab == 1 ? myData.saleCustomerNum : myData.totalPoints }}</div>
                            </div>
                        </div>
                        <p class="update-time">数据更新时间 {{ list && list[0] && list[0].etlTime }}</p>
                    </div>

                    <div class="bg-color"></div>
                </div>
            </div>
            <div class="ranking-box">
                <div class="tabs-box">
                    <div class="job-tabs">
                        <div>
                            <div class="job-tab-item" v-for="(it, ind) in jobTabs" :key="ind" :class="{ on: currentJobTab == it.dictValue }" @click="onJobTab(it)">
                                {{ it.dictLabel }}
                            </div>
                        </div>
                        <div class="group-tabs">
                            <div class="group-tab-item" :class="{ on: currentGroupTab == j }" v-for="(j, n) in jobTabs[currentJobTab - 1]?.groupTabs" :key="n" @click="onGroupTab(j)">
                                {{ j }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ranking-list-box">
                    <div class="myWrapper" v-if="myData">
                        <RankingItem :currentJobTab="currentJobTab" isMe :list="[myData]" :currentGroupTab="currentGroupTab" />
                    </div>
                    <div class="ranking-list-item title">
                        <div class="ranking-num">排名</div>
                        <div class="ranking-name">{{ jobTabs[currentJobTab - 1]?.title1 }}</div>
                        <div class="ranking-order">{{ jobTabs[currentJobTab - 1]?.title2 }}</div>
                        <div class="ranking-bonus">{{ jobTabs[currentJobTab - 1]?.title3 }}</div>
                    </div>
                    <RankingItem :currentJobTab="currentJobTab" :list="list" :currentGroupTab="currentGroupTab" :dataInfo="dataInfo" />
                </div>
            </div>
        </van-list>
    </div>
</template>

<script>
    import request from '@/utils/request'
    import RankingItem from './rankingItem.vue'
    import { debounce } from 'lodash';
    import { ActionSheet, Toast } from 'vant'

    export default {
        name: 'novYmRankList',
        components: {
            RankingItem,
            [ActionSheet.name]: ActionSheet
        },
        computed: {
            groupNoRewardAmtList() {
                return function (currentGroupTab) {// 添加防御性检查
                    if (!this.dataInfo || !this.dataInfo.groupNoRewardAmtObj) {
                        return []
                    }

                    return this.dataInfo?.groupNoRewardAmtObj?.rewardAmtList || []
                }
            }
        },
        data() {
            return {
                showRule: false, // 是否显示规则弹窗
                jobTabs: [], // 职位分类标签列表
                currentJobTab: '1',
                currentGroupTab: '第一组', // 当前选中的分组
                loading: false, // 是否正在加载
                currentMoldTab: '', // 当前选中第三层分组
                finished: false, // 是否加载完成
                list: [], // 排名列表数据
                page: 1, // 当前页码
                error: false, // 是否发生错误
                themeArr: [
                    {
                        "bgColor": "#FFE68F",
                        "url": "https://staticwecom.beautyfarm.com.cn/",
                        "bannerImg": "arrived1",
                        "title1": "姓名",
                        "title2": "销售人数 ",
                        "title3": "奖金"
                    },
                    {
                        "bgColor": "#8B020F",
                        "url": "https://staticwecom.beautyfarm.com.cn/",
                        "bannerImg": "arrived2",
                        "title1": "姓名",
                        "title2": "积分 ",
                        "title3": "奖金"
                    }
                ],
                dataInfo: {},  //后端整个详情
                myData: {},     //我的个人数据
            }
        },
        mounted() {
            this.getjobTabs()
        },
        methods: {
            // 初始化数据，获取销售列表
            getDataList: debounce(async function () {
                if (this.finished) return
                Toast.loading({
                    forbidClick: true,
                    duration: 0
                });
                try {
                    const params = {
                        groupNo: this.currentGroupTab,
                        page: this.page,
                        type: this.currentJobTab,
                        limit: 10
                    }
                    const { code, msg, data } = await request({
                        url: 'ym/christmas/ranking/getRankingInfoPage',
                        method: 'get',
                        params
                    })
                    if (code !== 0) {
                        throw new Error(msg)
                    }
                    Toast.clear();
                    // 对应jobTabs中的dataInfo赋值
                    this.dataInfo = data
                    this.myData = data.empRankingInfo
                    // 对赌激励取cspPkList ，销售纳新取cspMmbList
                    const list = data && data.rankingList
                    if (this.page == 1) {
                        this.list = list
                    } else {
                        this.list = this.list.concat(list)
                    }
                    this.page += 1
                    this.loading = false;

                    if (list.length < 10) {
                        this.finished = true;
                    }
                } catch (error) {
                    this.loading = false;
                    this.error = true;
                    // this.$toast(error)
                }

            }, 500),
            onLoad() {
                this.getDataList()
            },
            // 切换职位分类标签
            onJobTab(value) {
                this.currentJobTab = value.dictValue;
                this.page = 1
                this.finished = false
                this.error = false;
                this.getGroupTab()
            },
            // 切换分组标签
            onGroupTab(v) {
                this.currentGroupTab = v;
                this.finished = false
                this.error = false;
                this.page = 1
                this.getDataList()
            },
            toRule() {
                this.$router.push({ path: '/ssRankListRules', query: { currentJobTab: this.currentJobTab } })
            },
            // 获取职位分类标签
            async getjobTabs() {
                const { data } = await request({
                    url: '/dict/type/dictList',
                    method: 'get',
                    params: { dictType: 'novYmRankList_jobs' }
                })
                // 重组数据，该处理应新建数据进去
                const newArr = data.map((item, index) => {
                    return { ...item, ...this.themeArr[index] }
                })
                this.jobTabs = newArr
                await this.getGroupTab()
            },
            // 获取分组标签
            async getGroupTab() {
                const { data } = await request({
                    url: 'ym/christmas/ranking/getGroupNoTab',
                    method: 'get',
                    params: { type: this.currentJobTab }
                })
                // 分组组装数据
                this.jobTabs[this.currentJobTab - 1].groupTabs = data && data.groupNoList && data.groupNoList.length > 0 ? data.groupNoList : []
                // this.jobTabs[this.currentJobTab].groupNo = data && data.groupNo ? data.groupNo : data && data.list[0] // 默认选中
                // this.groupTabs = data && data.list && data.list.length > 0 ? data.list : []
                this.currentGroupTab = data && data.groupNo ? data.groupNo : data && data.groupNoList[0] // 默认选中
                this.getDataList()
            }
        }
    }
</script>

<style lang='less' scoped>
    .ranking {
        position: relative;
        height: 100%;
        font-size: 28px;
        overflow-y: scroll;
        color: #333333;
        background-color: #fff;

        .flex-around {
            display: flex;
            justify-content: space-around;
        }

        .flex-between {
            display: flex;
            justify-content: space-between;
        }
    }


    .myWrapper {
        padding: 20px;
    }

    .banner {
        width: 100%;
        min-height: 464px;
        height: 464px;
    }


    .reward-box {
        position: relative;
        width: 100%;
        margin-top: -94px;
        padding: 30px;
        text-align: center;
        background-color: #fff;
        border-radius: 40px;
        z-index: 9;


        .bear-palm {
            width: 100%;
            background: #F9F5F0;
            border-radius: 50px;
            padding: 0 63px;
            font-size: 26px;
            color: #333333;
            padding-bottom: 45px;

            >p {
                width: 325px;
                height: 70px;
                background: linear-gradient(84deg, #DCC7C1, #D4C7C2);
                border-radius: 0px 0px 40px 40px;
                margin: 0 auto;
                text-align: center;
                font-weight: bold;
                font-size: 36px;
                color: #FFFFFF;
                line-height: 70px;
                text-shadow: 1px 3px 0px rgba(60, 0, 94, 0.52);
                margin-bottom: 36px;
            }

            img {
                width: 100%;
            }

            .reward-bot {
                margin-bottom: 20px !important;
                display: flex;
                color: #666666;
                font-size: 24px;

                p {
                    width: calc(100% - 120px);
                    text-align: left;
                    margin: 0;
                    padding: 0;
                }
            }

            .prizeWrapper {
                margin-top: 40px;
                align-items: center;

                .prizeRank>div {
                    margin-bottom: 10px;
                    font-size: 30px;
                    color: red;
                }

                .prizeRank>.prizeTitle {
                    font-size: 26px;
                    color: #333333;
                }

                img {
                    width: 150px;
                }
            }

        }


    }


    .update-time {
        font-size: 24px;
        color: #999999;
        margin-top: 20px;
    }

    .ranking-box {
        overflow: hidden;
        background-color: #fff;
        border-radius: 40px 40px 0 0;
    }


    .tabs-box {
        padding: 0 30px;
    }

    .job-tabs {
        // display: flex;
        margin: 40px 0 10px 0;

        >div {
            display: flex;
            justify-content: space-around;
        }

        .group-tabs {
            display: flex;
            justify-content: flex-start;
            margin-bottom: 50px;
            overflow-x: auto;
        }
    }

    .job-tab-item {
        color: #999999;
        font-size: 30px;
        margin: 10px 0px 40px 0;
        font-weight: 500;
        text-align: center;
        border-radius: 30PX;
        position: relative;

        &.on {
            color: #333333;

            &::before {
                position: absolute;
                content: '';
                left: 50%;
                bottom: -15px;
                width: 40px;
                height: 6px;
                transform: translate(-50%);
                background-color: #333333;
                border-radius: 4px;
            }
        }
    }



    .group-tab-item {
        min-width: 22%;
        // margin-right: 30px;
        text-align: center;
        font-size: 26px;
        color: #333333;
        background-color: #E6E6E6;
        border-radius: 20px;
        padding: 3px 10px;
        margin-right: 23px;

        &.on {
            color: #333333;
            background-color: #DBC7C1;
        }
    }

    .ranking-list-box {
        border-top: 2px solid #eeeeee;
    }


    .ranking-list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin: 10px 0;
        padding: 30px 40px;
        border-bottom: 2px solid #eeeeee;

        &.title {
            padding-bottom: 0;
            border: none;
            color: #999999;
        }
    }

    .ranking-num {
        width: 60px;
        margin-right: 40px;


        >img {
            width: 50px;
            height: 60px;
        }
    }

    .ranking-name {
        display: flex;
        align-items: center;
        width: 240px;

        >.img {
            width: 60px;
            height: 60px;
            margin-right: 10px;
        }

    }

    .ranking-order {
        width: 160px;
        text-align: center;
    }

    .ranking-bonus {
        width: 180px;
        text-align: center;
    }




    .bg-color {
        height: 90px;
        margin: -30px 0;
        background-color: #E9E9E9;
    }


    .arrivedWrapper {
        display: flex;
        box-sizing: border-box;
        padding: 40px 78px;
        justify-content: space-between;

        .title {
            font-size: 24px;
            color: #333333;
        }

        .countWraper {
            >.content {
                font-size: 46px;
                color: #D62C18;
                font-weight: 500;

                span {
                    font-size: 30px;
                    font-weight: 500;
                }
            }

            >.content.isReach {
                color: #0072FF;
            }

            >.title {
                margin-bottom: 38px;
            }
        }

        .saleWrapper {
            >.content {
                font-size: 46px;
                color: #0072FF;
                font-weight: 500;
            }

            >.title {
                margin-bottom: 38px;
            }
        }
    }
</style>
<style lang="less">
    .ranking {

        .van-popup {
            overflow-y: visible;
        }

        .van-image__error {
            background-color: #A1A1A1;
        }

        .van-list__finished-text,
        .van-list__loading,
        .van-list__error-text {
            margin-top: -2px;
            background-color: #fff;
        }
    }
</style>
